import { isCookieModeActive, isCookieSessionActive } from "@/modules/auth/cookieMode.js"

// CH-37826: in cookie mode there is no token in localStorage to look at — the session is
// the HttpOnly cookie, which JS cannot read. Use the local session marker instead. Stays
// synchronous on purpose: asking the BFF for session-status on every navigation would add
// a round-trip for all ~170 hosts, and a stale marker self-corrects on the first 401.
const isAuthenticated = () =>
	isCookieModeActive() ? isCookieSessionActive() : Boolean(window.localStorage[process.env.VUE_APP_TOKEN_KEY])

// MOCK: this is mocked only for prototyping purposes
// This should be replaced with a solid guarding strategy that will
// include permission check for each route
const setupMockedAuthGuard = router => {
	router.beforeEach((to, from, next) => {
		// HACK: form forms remote, no need for token for demo
		if (to.name !== "ViewAuthLogin" && !isAuthenticated()) {
			// A BFF ?error= bounce must reach the login view; keeping it in returnUrl would replay it after login.
			const error = to.query?.error
			next({ name: "ViewAuthLogin", query: typeof error === "string" ? { error } : { returnUrl: to.fullPath } })
			return
		}
		next()
	})
}

export { setupMockedAuthGuard }
